import dayjs from "dayjs";
import React, { useState } from "react";
import ReactGA from "react-ga4";
import "./styles.scss";
import { useTranslation } from "react-i18next";

// import useRefreshLocationData, {
//   RefreshType,
// } from "../../../containers/FacilityDetailsPage/hooks/useRefreshLocationData";
import { SchedulePostData } from "../../../models/SchedulePostData";
// import DataSvc from "../../../services/dataSvc";
import { OptionalRender } from "../../Common/OptionalRender";
import { RecentMediaListContext } from "../../DashboardComponents/RecentPostsList";
import ModalUpdateGbpLocalPost from "../../FacilityDetailsComponents/ModalUpdateGbpLocalPost";
import ModalConfirm from "../../ModalConfirm";

export interface ISchedulePostItemProps {
  schedulePostItem: SchedulePostData;
  isShowLocationName?: boolean;
  context: RecentMediaListContext;
  canModify?: boolean;
  showEditButton?: boolean;
  showDeleteButton?: boolean;
  refreshCallback?: () => void;
  onEdit?: (schedulePost: SchedulePostData) => void;
}

export const SchedulePostItem: React.FunctionComponent<
  ISchedulePostItemProps
> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`localpostsPage.schedulePostItem.${key}`);

  const {
    schedulePostItem,
    isShowLocationName = true,
    context,
    canModify = false,
    // refreshCallback,
    showDeleteButton = false,
    showEditButton = false,
    onEdit,
  } = props;

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  // const refreshData = useRefreshLocationData(
  //   schedulePostItem.location_id.toString()
  // );

  // const hasMedia =
  //   schedulePostItem.media &&
  //   Array.isArray(schedulePostItem.media) &&
  //   schedulePostItem.media.length > 0;

  const mediaUrl = schedulePostItem.signed_url
    ? schedulePostItem.signed_url
    : "";

  const handleConfirmDelete = () => {
    setShowDeleteModal(true);
  };

  const handleCloseConfirmDelete = () => {
    setShowDeleteModal(false);
  };

  const handleDelete = async () => {
    // try {
    //   await DataSvc.deleteSchedulePost(
    //     schedulePostItem.location_id.toString(),
    //     schedulePostItem.id.toString()
    //   );
    //   setShowDeleteModal(false);
    //   refreshData(RefreshType.SCHEDULE_POSTS);
    //   refreshCallback?.();
    // } catch {
    //   // axios handles errors
    // }
  };

  const handleEdit = () => {
    // setShowUpdateModal(true);
    // ReactGA.event({
    //   category: "schedule-post",
    //   action: "Edit Schedule Post",
    // });
  };

  const handleUpdateSuccess = () => {
    // setShowUpdateModal(false);
    // refreshData(RefreshType.SCHEDULE_POSTS);
    // refreshCallback?.();
  };

  return (
    <>
      <div className="schedule-post-item">
        <div
          className="schedule-post-top-info"
          onClick={() =>
            ReactGA.event({
              category: "dashboard",
              action: "Open Schedule Post",
              label: context,
            })
          }
        >
          <div className="left-title">
            {isShowLocationName ? schedulePostItem.location_name : ""}
          </div>
          <div className="right-title">
            {dayjs(schedulePostItem.scheduled_at).format("YYYY-MM-DD HH:mm")}
          </div>
        </div>

        <div className="schedule-post-bottom-container">
          <div className="schedule-post-img-container">
            {mediaUrl ? (
              <img
                className="schedule-post-img"
                alt="schedule-post"
                src={mediaUrl}
              />
            ) : (
              <div className="no-image">
                <div>{t("no_picture")}</div>
              </div>
            )}
          </div>
          {schedulePostItem.summary ? (
            <div className="summary">{schedulePostItem.summary}</div>
          ) : (
            <div className="no-summary">{t("no_comment")}</div>
          )}
        </div>

        <div className="schedule-post-item-controls-container">
          <OptionalRender mustBeImpersonating>
            {canModify && showEditButton && (
              <button
                className="btn btn-border"
                onClick={onEdit ? () => onEdit(schedulePostItem) : handleEdit}
                type="button"
              >
                {t("edit")}
              </button>
            )}
          </OptionalRender>

          {canModify && showDeleteButton && (
            <button
              className="btn btn-red"
              onClick={handleConfirmDelete}
              type="button"
            >
              {t("delete")}
            </button>
          )}
        </div>
      </div>

      {showDeleteModal && (
        <ModalConfirm
          title={t("deleteModal.title")}
          cancelLabel={t("deleteModal.cancel")}
          confirmLabel={t("deleteModal.delete")}
          onClose={handleCloseConfirmDelete}
          onConfirm={handleDelete}
          translate={false}
          color="red"
        >
          <div className="delete-modal-schedule-post-preview-container">
            <SchedulePostItem
              key={schedulePostItem.id}
              schedulePostItem={schedulePostItem}
              isShowLocationName={true}
              context={RecentMediaListContext.OWN_LOCATION_HISTORY}
            />
          </div>
        </ModalConfirm>
      )}

      {showUpdateModal && (
        <ModalUpdateGbpLocalPost
          onClose={() => setShowUpdateModal(false)}
          localPost={schedulePostItem as any}
          onSuccess={handleUpdateSuccess}
        />
      )}
    </>
  );
};

export default SchedulePostItem;
